import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/AcessoRestrito.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../config';
import acessoRestritoImage from '../assets/imgprivilegio.png';

const apiUrl = config.apiUrl;

const AcessoPrivilegiado = () => {
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [acessos, setAcessos] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchAcessos();
  }, []);
  const handleTelefoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    
    
  
    setTelefone(value);
  };

  const fetchAcessos = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${apiUrl}/acessoprivilegiado/listar`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAcessos(response.data);
    } catch (error) {
      toast.error('Erro ao buscar acessos');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (telefone.length < 12) {
        toast.error('O número deve conter pelo menos 13 dígitos (incluindo o 55 e DDD)');
        return;
      }
    setIsSubmitting(true);
    const token = localStorage.getItem('token');
    try {
      await axios.post(`${apiUrl}/acessoprivilegiado/criar`, { nome, telefone }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Número cadastrado com sucesso!');
      setNome('');
      setTelefone('');
      fetchAcessos();
    } catch (error) {
      toast.error('Erro ao cadastrar número, tente novamente mais tarde!');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    try {
      await axios.delete(`${apiUrl}/acessoprivilegiado/deletar/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Número excluído com sucesso!');
      fetchAcessos();
    } catch (error) {
      toast.error('Erro ao excluir número, tente novamente mais tarde!');
    }
  };

  return (
    <div className="acesso-restrito-container">
      <h2>Acesso Privilegiado</h2>
      <img
        src={acessoRestritoImage}
        alt="Acesso Restrito"
        className="acesso-restrito-image"
      />

      <form className="acesso-restrito-form" onSubmit={handleSubmit}>
        <div className="acesso-restrito-form-group">
          <label htmlFor="nome">Nome</label>
          <input
            type="text"
            id="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Caso o contato esteja salvo, adicione o nome exato do contato salvo aqui."
            required
          />
        </div>
        <div className="acesso-restrito-form-group">
          <label htmlFor="telefone">Telefone</label>
          <input
            type="text"
            id="telefone"
            value={telefone}
            onChange={handleTelefoneChange}
            placeholder="Digite o número completo com DDD sem zeros. Exemplo: 5528999060768"
            required
          />
        </div>
        <button
          type="submit"
          className="acesso-restrito-button"
          disabled={isSubmitting}
        >
          Cadastrar
        </button>
      </form>

      <h2>Números Cadastrados</h2>
      <table className="acesso-restrito-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Telefone</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {acessos.map((item) => (
            <tr key={item.id}>
              <td>{item.nome}</td>
              <td>{item.telefone}</td>
              <td>
                <button
                  onClick={() => handleDelete(item.id)}
                  className="acesso-restrito-delete-button"
                >
                  Excluir
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AcessoPrivilegiado;
